import {
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  KProperty1ca4yb4wlo496 as KProperty1,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { Signal1973xs1vkmdcb as Signal } from '../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import {
  lastOrNull1aq5oz189qoe1 as lastOrNull,
  plus20p0vtfmu0596 as plus,
  dropLast1vpiyky649o34 as dropLast,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { rContextAddonInit1l0t8s3axt11t as rContextAddonInit } from '../views/ViewContextExtensions.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function set_pageNavigator(_this__u8e3s4, _set____db54di) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_pageNavigator_$ref_twffzs_0();
  return pageNavigator$delegate.qam(_this__u8e3s4, getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0_0()), _set____db54di);
}
function get_pageNavigator(_this__u8e3s4) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_pageNavigator_$ref_twffzs();
  return pageNavigator$delegate.oam(_this__u8e3s4, getPropertyCallableRef('pageNavigator', 1, tmp, tmp_0, _set_pageNavigator_$ref_jevpp0()));
}
var pageNavigator$delegate;
function set_mainPageNavigator(_this__u8e3s4, _set____db54di) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_mainPageNavigator_$ref_hg1lg1_0();
  return mainPageNavigator$delegate.qam(_this__u8e3s4, getPropertyCallableRef('mainPageNavigator', 1, tmp, tmp_0, _set_mainPageNavigator_$ref_nlnxvp_0()), _set____db54di);
}
function get_mainPageNavigator(_this__u8e3s4) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_mainPageNavigator_$ref_hg1lg1();
  return mainPageNavigator$delegate.oam(_this__u8e3s4, getPropertyCallableRef('mainPageNavigator', 1, tmp, tmp_0, _set_mainPageNavigator_$ref_nlnxvp()));
}
var mainPageNavigator$delegate;
function set_dialogPageNavigator(_this__u8e3s4, _set____db54di) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_dialogPageNavigator_$ref_a8dp28_0();
  return dialogPageNavigator$delegate.qam(_this__u8e3s4, getPropertyCallableRef('dialogPageNavigator', 1, tmp, tmp_0, _set_dialogPageNavigator_$ref_a8rp78_0()), _set____db54di);
}
function get_dialogPageNavigator(_this__u8e3s4) {
  _init_properties_Navigator_kt__ww6let();
  var tmp = KMutableProperty1();
  var tmp_0 = _get_dialogPageNavigator_$ref_a8dp28();
  return dialogPageNavigator$delegate.oam(_this__u8e3s4, getPropertyCallableRef('dialogPageNavigator', 1, tmp, tmp_0, _set_dialogPageNavigator_$ref_a8rp78()));
}
var dialogPageNavigator$delegate;
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {}
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
function PageNavigator$_get_routes_$ref_f110b8() {
  return (p0) => p0.jbw();
}
var PageNavigatorClass;
function PageNavigator() {
  if (PageNavigatorClass === VOID) {
    class $ {
      constructor(routesGetter) {
        this.ebn_1 = routesGetter;
        var tmp = this;
        tmp.fbn_1 = lazy(() => this.ebn_1());
        var tmp_0 = this;
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        tmp_0.gbn_1 = Signal().fak(tmp$ret$0);
        var tmp_1 = this;
        tmp_1.hbn_1 = remember(VOID, VOID, VOID, ($this$remember) => lastOrNull($this$remember.baj(this.gbn_1)));
        var tmp_2 = this;
        tmp_2.ibn_1 = remember(VOID, VOID, VOID, ($this$remember) => $this$remember.baj(this.gbn_1).p1() > 1);
      }
      jbw() {
        var tmp0 = this.fbn_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('routes', 1, tmp, PageNavigator$_get_routes_$ref_f110b8(), null);
        return tmp0.f2();
      }
      ld6(screen) {
        return screen;
      }
      dbw(screen) {
        return this.md6(this.ld6(screen));
      }
      nd6(screen) {
        return this.od6(this.ld6(screen));
      }
      ebw(screen) {
        return this.pd6(this.ld6(screen));
      }
      md6(screen) {
        var _receiver__tnumb7 = this.gbn_1;
        _receiver__tnumb7.mam(plus(_receiver__tnumb7.f2(), screen));
      }
      od6(screen) {
        this.gbn_1.mam(plus(dropLast(this.gbn_1.f2(), 1), screen));
      }
      pd6(screen) {
        this.gbn_1.mam(listOf(screen));
      }
      qd6() {
        if (this.gbn_1.f2().p1() <= 1)
          return false;
        this.gbn_1.mam(dropLast(this.gbn_1.f2(), 1));
        return true;
      }
      rd6() {
        if (this.gbn_1.f2().i1())
          return false;
        this.gbn_1.mam(dropLast(this.gbn_1.f2(), 1));
        return true;
      }
      v3() {
        // Inline function 'kotlin.collections.listOf' call
        var tmp$ret$0 = emptyList();
        this.gbn_1.mam(tmp$ret$0);
      }
    }
    initMetadataForClass($, 'PageNavigator');
    PageNavigatorClass = $;
  }
  return PageNavigatorClass;
}
function _get_pageNavigator_$ref_twffzs() {
  return (p0) => get_pageNavigator(p0);
}
function _set_pageNavigator_$ref_jevpp0() {
  return (p0, p1) => {
    set_pageNavigator(p0, p1);
    return Unit_instance;
  };
}
function _get_pageNavigator_$ref_twffzs_0() {
  return (p0) => get_pageNavigator(p0);
}
function _set_pageNavigator_$ref_jevpp0_0() {
  return (p0, p1) => {
    set_pageNavigator(p0, p1);
    return Unit_instance;
  };
}
function _get_mainPageNavigator_$ref_hg1lg1() {
  return (p0) => get_mainPageNavigator(p0);
}
function _set_mainPageNavigator_$ref_nlnxvp() {
  return (p0, p1) => {
    set_mainPageNavigator(p0, p1);
    return Unit_instance;
  };
}
function _get_mainPageNavigator_$ref_hg1lg1_0() {
  return (p0) => get_mainPageNavigator(p0);
}
function _set_mainPageNavigator_$ref_nlnxvp_0() {
  return (p0, p1) => {
    set_mainPageNavigator(p0, p1);
    return Unit_instance;
  };
}
function _get_dialogPageNavigator_$ref_a8dp28() {
  return (p0) => get_dialogPageNavigator(p0);
}
function _set_dialogPageNavigator_$ref_a8rp78() {
  return (p0, p1) => {
    set_dialogPageNavigator(p0, p1);
    return Unit_instance;
  };
}
function _get_dialogPageNavigator_$ref_a8dp28_0() {
  return (p0) => get_dialogPageNavigator(p0);
}
function _set_dialogPageNavigator_$ref_a8rp78_0() {
  return (p0, p1) => {
    set_dialogPageNavigator(p0, p1);
    return Unit_instance;
  };
}
var properties_initialized_Navigator_kt_hi8lg9;
function _init_properties_Navigator_kt__ww6let() {
  if (!properties_initialized_Navigator_kt_hi8lg9) {
    properties_initialized_Navigator_kt_hi8lg9 = true;
    pageNavigator$delegate = rContextAddonInit();
    mainPageNavigator$delegate = rContextAddonInit();
    dialogPageNavigator$delegate = rContextAddonInit();
  }
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  PageNavigator as PageNavigator20tezdf2xr1uc,
  get_dialogPageNavigator as get_dialogPageNavigator3pxggbj34kkoa,
  set_dialogPageNavigator as set_dialogPageNavigator1900z53fhaufv,
  get_mainPageNavigator as get_mainPageNavigator29w1pddlp5wea,
  set_mainPageNavigator as set_mainPageNavigator2pkpulo0hvwfl,
  get_pageNavigator as get_pageNavigator1inl9j7ja0vlf,
  set_pageNavigator as set_pageNavigator2t8ucpwsozusv,
};
//endregion

//# sourceMappingURL=Navigator.mjs.map
